/** @description Вычисляет величину левого отступа на который нужно сдвинуть содержимое контейнера слайдов
 *  для отображения требуемого слайда
 * @param {number} props.leftEarWidth ширина левого уха в пикселях
 * @param {number} props.gapWidth ширина разрыва между слайдами в пикселях
 * @param {number} props.slideWidth ширина слайда в пикселях
 * @param {number} props.currentSlideIndex индекс отображаемого слайда в общем массиве слайдов
 * @param {number} props.slidesToShow число одновременно отображаемых слайдов на экране
 * @return {number}
 */
export function calculateOffset(props) {
  var leftEarWidth = props.leftEarWidth,
    gapWidth = props.gapWidth,
    slideWidth = props.slideWidth,
    currentSlideIndex = props.currentSlideIndex,
    slidesToShow = props.slidesToShow;
  return leftEarWidth - (currentSlideIndex - (slidesToShow - 1)) * (gapWidth + slideWidth);
}
/** @description Вычисляет величину левого отступа на который нужно сдвинуть содержимое контейнера слайдов
 *  для отображения требуемого слайда при серверном рендеринге
 * @param {string} props.leftEarWidth ширина левого уха в пикселях
 * @param {string} props.gapWidth ширина разрыва между слайдами в пикселях
 * @param {string} props.slideWidth ширина слайда в пикселях
 * @param {number} props.currentSlideIndex индекс отображаемого слайда в общем массиве слайдов
 * @param {number} props.slidesToShow число одновременно отображаемых слайдов на экране
 * @return {string}
 */
export function calculateOffsetSSR(props) {
  var leftEarWidth = props.leftEarWidth,
    gapWidth = props.gapWidth,
    slideWidth = props.slideWidth,
    currentSlideIndex = props.currentSlideIndex,
    slidesToShow = props.slidesToShow;
  return "calc(".concat(leftEarWidth, " - (").concat(currentSlideIndex - (slidesToShow - 1), " * (").concat(gapWidth, " + ").concat(slideWidth, ")))");
}